// extracted by mini-css-extract-plugin
export default {"headingWrapper":"Header_headingWrapper__izbt6","heading":"Header_heading__sdLqL"};